import styled from 'styled-components';

const Bound = styled.div`
    font-family: "UTM-Avo";
    ${props => props.extendStyles}
`;

export { Bound }